import React, { Component } from 'react'

import loadingGif from '../../assets/img/loading.gif'

class Loading extends Component {
    render() {
        return(
            <img src={loadingGif} alt="Loading..." />
        )
    }
}

export default Loading